import React from 'react';
import { Iterable } from 'immutable';

/**
 * Higher order component to convert any immutable.js props objects into plain JS objects.
 * This helps keep immutable JS out of our components.
 * @param {React Component} WrappedComponent
 * see: http://redux.js.org/docs/recipes/UsingImmutableJS.html#use-a-higher-order-component-to-convert-your-smart-components-immutablejs-props-to-your-dumb-components-javascript-props
 */
const toJS = WrappedComponent => wrappedComponentProps => {
	const KEY = 0;
	const VALUE = 1;
	const propsJS = Object.entries(wrappedComponentProps).reduce((newProps, wrappedComponentProp) => {
		// eslint-disable-next-line no-param-reassign
		newProps[wrappedComponentProp[KEY]] = Iterable.isIterable(wrappedComponentProp[VALUE])
			? wrappedComponentProp[VALUE].toJS()
			: wrappedComponentProp[VALUE];
		return newProps;
	}, {});

	return <WrappedComponent {...propsJS} />;
};

export default toJS;
